"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheBoutiqueDifference() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-boutique-difference" className="relative w-full !bg-[hsl(210,17%,98%)] !h-[550px]">
      {}
      <Separator className="bg-border/80" />

      <div ref={ref} className="mx-auto flex max-w-[800px] flex-col items-center gap-8 px-6 py-24 text-center transition-all duration-1000 ease-out opacity-100 translate-y-0 !h-[550px]">
        {}
        <h2 className="text-primary text-3xl font-bold tracking-tight ![padding:30px_0px_30px_0px] md:text-4xl">Built on the Bedrock of Storytelling</h2>

        {}
        <div className="text-foreground/80 font-sans space-y-6 text-lg leading-[1.6]">
          <p className="!text-[hsl(210,10%,23%)] !text-xl">SayKen is built on the bedrock of storytelling. Together, we will immerse into the landscapes that have shaped the world’s most enduring stories. From the whispers of the past in the scriptures to the echoes of the Crusaders, every step is a verse in the grand narrative of this timeless land. Just Say Ken which is not only my name but means Yes in Hebrew(!), and embark on an unforgettable odyssey.</p>
          
        </div>

        {}
        <div className="mt-4 flex w-full justify-center">
          
        </div>
      </div>

      {}
      <Separator className="bg-border/80" />
    </section>;
}